import React, {Component} from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import Util from '../../forecast-app/shared/util/util';

class AddedLabel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uuid: uuid.v4(), // Generate id
		};
	}

	render() {
		const color = Util.getTextColor(this.props.label.color);
		return (
			<span className={'newly-added-label added-label' + (this.props.disabled ? '' : ' clickable')} style={{color: color, backgroundColor: this.props.label.color}}>
				<label className="label-text" htmlFor={this.state.uuid}>
					{this.props.label.label}
				</label>
				{this.props.onDeleteClick && !this.props.disabled ? <button className="remove-label-button" id={this.state.uuid} onClick={() => this.props.onDeleteClick(this.props.label)} tabIndex={0} disabled={this.props.disabled} /> : ''}
			</span>
		);
	}
}

AddedLabel.propTypes = {
	label: PropTypes.shape({
		value: PropTypes.string,
		label: PropTypes.string,
		color: PropTypes.string,
	}).isRequired,
	onDeleteClick: PropTypes.func,
	disabled: PropTypes.bool,
};

export default AddedLabel;
